import { useStyles } from './styles'
import { CaseList } from '@/shared/ui/caseList'
import { useEffect, useState } from 'react'
import { useUnit } from 'effector-react'
import { $casesList, $lastViewedCaseId } from '@/entities/cases'
import { lang } from '@/shared/constants/lang'
import { $userLanguage, $userToken, authUserFx } from '@/entities/user'
import { getCaseContentFx, getCaseListFx, getUniqueContentFx } from '@/entities/cases'
import { CaseKind } from '@/entities/cases'
import { Case } from '@/entities/cases'
import { YourKeys } from '@/features/yourKeys'
import DailyCaseBanner from '@/features/dailyCaseBanner'
import { ShopPrimarySkeleton } from './skeleton'

export const ShopPrimary = () => {
  const caseList = useUnit($casesList)

  const lastViewedCaseId = useUnit($lastViewedCaseId) ?? 1
  const caseKind = caseList?.find((_case) => _case.id == lastViewedCaseId)?.kind
  const userLang = useUnit($userLanguage)
  const { classes } = useStyles({})
  const userToken = useUnit($userToken)
  useEffect(() => {
    if (!caseList && userToken) getCaseListFx({ token: userToken })
  }, [caseList, userToken])

  useEffect(() => {
    if (userToken == null) {
      authUserFx()

      return
    }
    getCaseListFx({ token: userToken })
    getCaseContentFx({ token: userToken!, id: lastViewedCaseId })
    if (caseKind === CaseKind.UNIQUE) {
      getUniqueContentFx({ token: userToken!, id: lastViewedCaseId })
    }
  }, [userToken, lastViewedCaseId, caseKind])

  const [availableCases, setAvailableCases] = useState<Case[]>([])
  const [legacyCases, setLegacyCases] = useState<Case[]>([])
  useEffect(() => {
    if (caseList) {
      setAvailableCases(caseList.filter((_case) => _case.active))
      setLegacyCases(caseList.filter((_case) => !_case.active))
    }
  }, [caseList])

  const texts = lang[userLang].pages.boxPage
  const shopTexts = lang[userLang].pages.shop

  if (!caseList) return <ShopPrimarySkeleton />

  return (
    <div className={classes.root}>
      <h1 className={classes.heading}>{shopTexts.shopHeading}</h1>
      <YourKeys />

      <DailyCaseBanner variant="secondary" />
      <h2 className={classes.caseListHeading}>{texts.availableCases}</h2>
      <CaseList sortBy="name" data={availableCases} />
      <h2 className={classes.caseListHeading}>{texts.legacy}</h2>
      <CaseList sortBy="name" data={legacyCases} />
    </div>
  )
}
